import React from 'react';
import withRadioPlayerContext from '../context/withRadioPlayerContext';
import withAllContexts from '../context/withAllContexts';
import addIfMissingComponent from '../util/addIfMissingComponent';

const Header = ({ children }) => (<>{addIfMissingComponent(children, "HeaderComponent")}</>);

export default withAllContexts(withRadioPlayerContext(Header));
